import { usePaginatedQuery } from "react-query-legacy";
import { BillingEngineService } from "services";

const manualStockEntryQueryKey = "manual-stock-entries";

function useQueryStockEntries(params: any) {
  return usePaginatedQuery([manualStockEntryQueryKey, params], BillingEngineService.getStockEntries, {
    retry: false,
  });
}

export { manualStockEntryQueryKey };
export default useQueryStockEntries;
